import styled from 'styled-components'

export const StyledLocationMap = styled.div`
    @media (max-width: 992px) { 
      margin-top: 20px;
    }
  }
`;